export const common = {
  loading: '加载中...',
  save: '保存',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  delete: '删除',
  edit: '编辑',
  back: '返回',
  next: '下一步',
  submit: '保存',
  search: '搜索',
  filter: '筛选',
  sort: '排序',
  more: '更多',
  less: '更少',
  yes: '是',
  no: '否',
  ok: '完成',
  error: '错误',
  success: '成功',
  warning: '警告',
  info: '信息',
  
  // Global loading states
  loadingData: '加载仪表板数据...',
  loadError: '加载仪表板数据失败',
  retry: '重试',
};

export const timeAgo = {
  today: '今天',
  yesterday: '昨天',
  daysAgo: '{count} 天前',
  weekAgo: '1 周前',
  weeksAgo: '{count} 周前',
  monthAgo: '1 个月前',
  monthsAgo: '{count} 个月前',
};
